import React from 'react'
import { Card, Col, Row, Input,CardHeader, Badge } from 'reactstrap';
import './StyleProfile.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';

export const InformationPriceComercialLine = (props) => {

    const {
        objj, handleChange, index, handleDeleteExamGlobal, handleChangeSinToma, handleChangeConToma, totalCommercialLines,
        sampling_cost, findFirstPrice,handleprices,porcentaje,typeKit,setFindRate, searchTerm, setSearchTerm, exportToExcel,

        //? ALERT DELETE
        saveDeleteExamProfile,
        modalAlert,
        showDeleteAlert,
        deleteExamData,
        openDeleteAlert,
        closeDeleteAlert
         } = props;
        console.log("🚀 ~ InformationPriceComercialLine ~ objj:", objj)

     //* VALIDATIONS KIT SAMPLE
    let _validSize = typeKit === false ? 4 : 2
    let _validSizeImg = typeKit === false ? 4 : 3
    let _validSizeRange =  typeKit === false ? 4 : 3
    let _validMatraz =   typeKit === false ? 3 : 2

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };
    
    const header = (
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <button
                className="p-button p-button-success"
                onClick={exportToExcel}
                title="Listado de resultados"
                style={{
                    alignItems: "center",
                    padding: "5px 8px",
                    height: "35px",
                    width: "35px",
                    fontSize: "0.9rem",
                }}
            >
                <i className="pi pi-file-excel" style={{ fontSize: "1rem", marginRight: "5px" }}></i>
            </button>
            
            <Input
                type="search"
                placeholder="Buscar....."
                value={searchTerm}
                className="form-control"
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                    maxWidth: "400px",
                    borderRadius: "8px",
                    padding: "6px 10px",
                    fontSize: "14px",
                }}
            />
        </div>
    );

    
    return (
        <>
            {
                objj !== null ?
               
                       
                    <Card>
                        <CardHeader className='text-center p-1' style={{background: '#115d91ff'}}>
                            <h6 className='pt-1' style={{color: '#ffff'}}>  <strong>{objj.name_rate}</strong></h6>
                        </CardHeader>
                
                        <Row sm="12" className="align-items-center border-bottom">
                            <Col sm="12">
                                
                                    {
                                        totalCommercialLines.length >= 1 && totalCommercialLines.map((obj, key) => {
                                            if (obj.id_rate == objj.id_rate) {

                                                let priceG = (obj.total_venta_publico_general.toFixed(2))
                                                localStorage.setItem("Perfil", priceG);
                                                return (
                                                    <>
                                                    {
                                                        //*PRICES AND KIT SAMPLE
                                                    }
                                                    <Row key={key} className="g-3 justify-content-start">
                                                        <Col xs={12} sm={6} md={4} lg={4}>
                                                            <div className="card-price shadow-sm p-3 hover-card" style={{ borderRadius: "12px", backgroundColor: "#fdfdfd", textAlign: "center", transition: "all 0.3s" }}>
                                                            <strong style={{ fontSize: "13px", color: "#555" }}>Precio de Venta Individual</strong>
                                                            <h5 className="value text-secondary mt-2" style={{ fontWeight: "600", fontSize: "18px" }}>
                                                                <Badge
                                                                color="light"
                                                                pill
                                                                style={{ fontSize: "12px", color: "#333", marginRight: "4px", padding: "2px 6px" }}
                                                                >
                                                                $
                                                                </Badge>
                                                                {obj.total_venta_publico_general.toFixed(2)}
                                                            </h5>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} sm={6} md={4} lg={4}>
                                                            <div className="card-price shadow-sm p-3 hover-card" style={{ borderRadius: "12px", backgroundColor: "#e8f5e9", textAlign: "center", transition: "all 0.3s" }}>
                                                            <p className="title" style={{ fontSize: "13px", color: "#28a745" }}>Precio del Perfil al Público</p>
                                                            <h5 className="value text-success mt-2" style={{ fontWeight: "600", fontSize: "18px", display: "flex", justifyContent: "center", alignItems: "center", gap: "6px" }}>
                                                                <Badge
                                                                color="light"
                                                                pill
                                                                style={{ fontSize: "12px", color: "#28a745", padding: "2px 6px" }}
                                                                >
                                                                $
                                                                </Badge>
                                                                {objj.price_profile == null
                                                                ? findFirstPrice?.price?.toFixed(2) ?? "0.00"
                                                                : objj.price_profile.toFixed(2)}
                                                                <Button
                                                                outline
                                                                color="success"
                                                                size="sm"
                                                                style={{ borderRadius: "20px", padding: "2px 8px", fontSize: "12px" }}
                                                                onClick={() => handleprices(key, priceG, obj.id_rate)}
                                                                >
                                                                <i className="icofont icofont-cur-dollar"></i>
                                                                </Button>
                                                            </h5>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} sm={6} md={4} lg={4}>
                                                            <div className="card-price shadow-sm p-3 hover-card" style={{ borderRadius: "12px", backgroundColor: "#fdfdfd", textAlign: "center", transition: "all 0.3s" }}>
                                                            <p className="title" style={{ fontSize: "13px", color: "#555" }}>Precio Mínimo del Perfil</p>
                                                            <h5 className="value text-secondary mt-2" style={{ fontWeight: "600", fontSize: "18px" }}>
                                                                <Badge
                                                                color="light"
                                                                pill
                                                                style={{ fontSize: "12px", color: "#333", marginRight: "4px", padding: "2px 6px" }}
                                                                >
                                                                $
                                                                </Badge>
                                                                {obj.minimoProduccion.toFixed(2)}
                                                            </h5>
                                                            </div>
                                                        </Col>

                                                        {typeKit && (
                                                            <>
                                                            <Col xs={12} sm={6} md={4} lg={4}>
                                                                <div className="card-price shadow-sm p-3 hover-card" style={{ borderRadius: "12px", backgroundColor: "#fff3cd", textAlign: "center", transition: "all 0.3s" }}>
                                                                <p className="title" style={{ fontSize: "13px", color: "#856404" }}>Costo de Toma de Muestra</p>
                                                                <h5 className="value text-secondary mt-2" style={{ fontWeight: "600", fontSize: "18px" }}>
                                                                    <Badge color="light" pill style={{ fontSize: "12px", color: "#856404", marginRight: "4px", padding: "2px 6px" }}>
                                                                    $
                                                                    </Badge>
                                                                    {sampling_cost?.toFixed(2)}
                                                                </h5>
                                                                </div>
                                                            </Col>

                                                            <Col xs={12} sm={6} md={4} lg={4}>
                                                                <div className="card-price shadow-sm p-3 hover-card" style={{ borderRadius: "12px", backgroundColor: "#d1ecf1", textAlign: "center", transition: "all 0.3s" }}>
                                                                <p className="title" style={{ fontSize: "13px", color: "#0c5460" }}>Precio Maquila con Toma</p>
                                                                <h5 className="value text-primary mt-2" style={{ fontWeight: "600", fontSize: "18px" }}>
                                                                    <Badge color="light" pill style={{ fontSize: "12px", color: "#0c5460", marginRight: "4px", padding: "2px 6px" }}>
                                                                    $
                                                                    </Badge>
                                                                    {obj.descuento_Maquila_sin_toma.toFixed(2)}
                                                                </h5>
                                                                </div>
                                                            </Col>

                                                            <Col xs={12} sm={6} md={4} lg={4}>
                                                                <div className="card-price shadow-sm p-3 hover-card" style={{ borderRadius: "12px", backgroundColor: "#d1ecf1", textAlign: "center", transition: "all 0.3s" }}>
                                                                <p className="title" style={{ fontSize: "13px", color: "#0c5460" }}>Precio Maquila sin Toma</p>
                                                                <h5 className="value text-primary mt-2" style={{ fontWeight: "600", fontSize: "18px" }}>
                                                                    <Badge color="light" pill style={{ fontSize: "12px", color: "#0c5460", marginRight: "4px", padding: "2px 6px" }}>
                                                                    $
                                                                    </Badge>
                                                                    {obj.descuento_Maquila_con_toma.toFixed(2)}
                                                                </h5>
                                                                </div>
                                                            </Col>
                                                            </>
                                                        )}
                                                    </Row>

                                                    </>
                                                )
                                            }
                                        })
                                    }
                                
                            </Col>
                        </Row>
                        <br />
                        <Col>

                            {objj?.exams && objj.exams.length > 0 && (
                                <Row>
                                    <br /><br /><br />
                                    <div className="table-responsive">
                                        <DataTable
                                            value={(objj?.exams ?? []).filter(exam =>
                                                    exam.name_exam.toLowerCase().includes(searchTerm.toLowerCase())
                                                )}                                            responsiveLayout="scroll"
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            paginator
                                            rows={7}
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "40%" }} alt="Sin Cotizaciones" />
                                                    <br />
                                                    <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>Sin estudios en el perfil.</p>
                                                </div>
                                            }
                                            rowsPerPageOptions={[7, 50, 100]}
                                            header={header}  
                                            
                                        >
                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />

                                            <Column 
                                                header="Estudios/Perfil"
                                                body={(rowData) => (
                                                    <div className='d-flex align-items-center'>
                                                        <img 
                                                            src={require("../../../assets/images/loginHelenLabs/Profile/PriceProfile.svg")} 
                                                            alt="perfil" 
                                                            style={{ width: "50px", marginRight: "10px" }}
                                                        />
                                                        <span>{rowData.name_exam}</span>
                                                    </div>
                                                )}
                                                headerStyle={headerStyle} style={{fontSize: "12px", textAlign: "left"}}
                                            />

                                            <Column 
                                                header="Precio de venta al público" 
                                                body={(rowData) => `$ ${rowData.price.toFixed(2)}`} 
                                                headerStyle={headerStyle} 
                                                style={cellStyle}
                                            />

                                            {/* <Column 
                                                header="Descuento (%)"
                                                body={(rowData, meta) => {
                                                    if (!rowData) return null;

                                                    const { rowIndex } = meta;

                                                    const maxPercentage = rowData.price
                                                    ? (100 - (Math.ceil((rowData.production_price / rowData.price) * 1000) / 10)).toFixed(2)
                                                    : 0;

                                                    const discountValue = (rowData.price * rowData.percentage / 100).toFixed(2);

                                                    return (
                                                    <div 
                                                        style={{ 
                                                        display: "flex", 
                                                        flexDirection: "column", 
                                                        alignItems: "center", 
                                                        justifyContent: "center",
                                                        gap: "5px",
                                                        width: "100%" 
                                                        }}
                                                    >
                                                        <InputNumber
                                                        className="input-air-primary"
                                                        min={0}
                                                        max={maxPercentage}
                                                        value={rowData.percentage}
                                                        onValueChange={(e) => handleChange(e, rowData.id_exam, index, rowIndex)}
                                                        />

                                                        <div style={{ fontSize: '11px', textAlign: 'center' }}>
                                                        <b>Descuento:</b> {rowData.percentage}% = <span style={{ color: '#d9534f' }}>${discountValue}</span>
                                                        </div>
                                                    </div>
                                                    )
                                                }}
                                                headerStyle={headerStyle} style={cellStyle}
                                            /> */}
                                            <Column 
                                                header="Descuento (%)"
                                                body={(rowData, meta) => {
                                                    if (!rowData) return null;

                                                    const { rowIndex } = meta;

                                                    const maxPercentage = (() => {
                                                        if (!rowData.price || rowData.price <= 0) return 0;

                                                        const raw = 100 - ((rowData.production_price / rowData.price) * 100);

                                                        if (!isFinite(raw) || raw < 0) return 0;

                                                        return Number(raw.toFixed(2));
                                                    })();

                                                    const discountValue =
                                                        (rowData.price > 0 && rowData.percentage >= 0)
                                                            ? (rowData.price * rowData.percentage / 100).toFixed(2)
                                                            : "0.00";

                                                    return (
                                                        <div 
                                                            style={{ 
                                                            display: "flex", 
                                                            flexDirection: "column", 
                                                            alignItems: "center", 
                                                            justifyContent: "center",
                                                            gap: "5px",
                                                            width: "100%" 
                                                            }}
                                                        >
                                                            <InputNumber
                                                                className="input-air-primary"
                                                                min={0}
                                                                max={maxPercentage}
                                                                value={rowData.percentage}
                                                                onValueChange={(e) => handleChange(e, rowData.id_exam, index, rowIndex)}
                                                            />

                                                            <div style={{ fontSize: '11px', textAlign: 'center' }}>
                                                                <b>Descuento:</b> {rowData.percentage}% =
                                                                <span style={{ color: '#d9534f' }}>${discountValue}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                }}
                                                headerStyle={headerStyle}
                                                style={cellStyle}
                                            />

                                            <Column header="Precio Final" body={(rowData) => `$ ${rowData.total.toFixed(2)}`} headerStyle={headerStyle} style={cellStyle} />

                                            {typeKit && (
                                                <Column 
                                                    header="Maquila Sin T.M."
                                                    body={(rowData, rowIndex) => {
                                                        const array2 = ((rowData.price * rowData.percentage_without_toma) / 100).toFixed(2);
                                                        const maxPercentage = (100 - (Math.ceil((rowData.production_price / rowData.price) * 1000) / 10)).toFixed(2);
                                                        return (
                                                            <div>
                                                                <div>Descuento: {rowData.percentage_without_toma}% = <b>${array2}</b></div>
                                                                <InputNumber 
                                                                    value={rowData.percentage_without_toma} 
                                                                    min={0} 
                                                                    max={maxPercentage} 
                                                                    onValueChange={(e) => handleChangeSinToma(e, rowData.id_exam, rowIndex)}
                                                                    mode="decimal"
                                                                />
                                                                <div>Precio Final: ${rowData.total_without_toma.toFixed(2)}</div>
                                                            </div>
                                                        )
                                                    }}
                                                    headerStyle={headerStyle} style={cellStyle}
                                                />
                                            )}

                                            {typeKit && (
                                                <Column 
                                                    header="Maquila Con T.M."
                                                    body={(rowData, rowIndex) => {
                                                        const array3 = ((rowData.price * rowData.percentage_with_toma) / 100).toFixed(2);
                                                        const maxPercentage = (100 - (Math.ceil((rowData.production_price / rowData.price) * 1000) / 10)).toFixed(2);
                                                        return (
                                                            <div>
                                                                <div>Descuento: {rowData.percentage_with_toma}% = <b>${array3}</b></div>
                                                                <InputNumber 
                                                                    value={rowData.percentage_with_toma} 
                                                                    min={0} 
                                                                    max={maxPercentage} 
                                                                    onValueChange={(e) => handleChangeConToma(e, rowData.id_exam, rowIndex)}
                                                                    mode="decimal"
                                                                />
                                                                <div>Precio Final: ${rowData.total_with_toma.toFixed(2)}</div>
                                                            </div>
                                                        )
                                                    }}
                                                    headerStyle={headerStyle} style={cellStyle}
                                                />
                                            )}

                                            <Column
                                                header="Acciones"
                                                body={(rowData) => (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        <button
                                                            onClick={() => openDeleteAlert(rowData)}
                                                            title="Eliminar"
                                                            className="btnTableAction"
                                                            style={{
                                                                backgroundColor: "#bf0d0d"
                                                            }}
                                                        >
                                                            <i className="fa fa-trash"></i>
                                                        </button>
                                                    </div>
                                                )}
                                                headerStyle={headerStyle}
                                                bodyStyle={{
                                                    textAlign: "center"
                                                }}
                                            />
                                        </DataTable>
                                    </div>
                                </Row>
                            )}

                        </Col>
                        
          
                        {/* {findFirstPrice !== undefined && (
                            <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end", 
                                marginTop: "10px",
                            }}
                            >
                            <div
                                style={{
                                display: "inline-flex",
                                alignItems: "center",
                                backgroundColor: "#bbdefb",
                                padding: "4px 12px",
                                borderRadius: "20px",
                                fontWeight: "600",
                                color: "#164c79",
                                fontSize: "0.9rem",
                                whiteSpace: "nowrap",
                                }}
                            >
                                <i
                                className="icofont icofont-money"
                                style={{
                                    fontSize: "1.1rem",
                                    color: "#1976d2",
                                    marginRight: "6px",
                                }}
                                ></i>
                                Precio inicial del Perfil:&nbsp; ${findFirstPrice.price.toFixed(2)}
                            </div>
                            </div>
                        )} */}
                        
                    </Card>
                   
                    :
                    ""
            }


            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar examen"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el examen?"
                    alert1={true}
                    titleAlert1={deleteExamData.name_exam}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDeleteExamProfile}
                />
            )}

        </>
        
    )
}
